import { motion } from "framer-motion";
import { PROFILE } from "../data/projects";

const B = "https://mir-s3-cdn-cf.behance.net/projects/808";
const D = (id) => `https://drive.google.com/thumbnail?id=${id}&sz=w800`;

const COLLAGE = [
  [
    `${B}/132896254658429.Y3JvcCwxOTk5LDE1NjQsMCw3MTc.png`,
    D("15Qc6IwkD5EkB9AHiHQUL-GQoUmzzR3Tg"),
    D("1OUC92hHLz8ZO178qCqCA0UnEaltTii-L"),
  ],
  [
    `${B}/d26df9254657577.Y3JvcCwxNTM0LDEyMDAsMTMyLDA.png`,
    D("1sha25l-1vrp3ZCQJsxbuiTNcJKOM26hd"),
    D("1zTP2IY_E96HQvsMYlLtmB3fJyIm-aOiW"),
  ],
  [
    `${B}/9b0481254657315.Y3JvcCw3OTcyLDYyMzYsMzQ5Miww.jpg`,
    D("1Aie9nnhwtMnZi_iw8fNpXg2FCOOQ08To"),
    D("1m4QimiCJrAJtSYExR_AFZ4BqkrtWoB1q"),
  ],
  [
    `${B}/1e85ba254657133.Y3JvcCwyMzExLDE4MDcsMCwyMg.png`,
    D("1_gdOspTEthmUrbHp0jwKluYEkf8xY3X9"),
    `${B}/d6392c254657665.Y3JvcCw1MDAwLDM5MTAsMCw1NDQ.png`,
  ],
];

const Collage = () => (
  <div className="absolute inset-0 overflow-hidden" aria-hidden>
    <div className="absolute -inset-x-8 -top-24 -bottom-24 grid -rotate-3 grid-cols-3 gap-4 opacity-60 md:grid-cols-4">
      {COLLAGE.map((col, ci) => (
        <div
          key={ci}
          className={`collage-col ${ci % 2 === 0 ? "collage-up" : "collage-down"} ${ci === 3 ? "hidden md:flex" : ""}`}
        >
          {[...col, ...col].map((src, i) => (
            <img key={i} src={src} alt="" loading="lazy" className="h-64 w-full rounded-lg object-cover" />
          ))}
        </div>
      ))}
    </div>
    <div className="absolute inset-0 bg-black/85" />
  </div>
);

export const Hero = () => (
  <section
    id="home"
    data-testid="hero-section"
    className="relative flex min-h-screen items-center justify-center overflow-hidden"
  >
    <Collage />

    <div className="relative z-10 px-6 text-center">
      <motion.span
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.2 }}
        className="mb-6 inline-block rounded-full border border-white/30 px-5 py-1.5 text-xs font-normal uppercase tracking-[0.2em] text-white/85"
      >
        Available for Full-Time Roles
      </motion.span>
      <div className="overflow-hidden">
        <motion.h1
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
          data-testid="hero-name"
          className="text-5xl font-semibold tracking-tight text-white md:text-7xl"
        >
          Harshith Holla
        </motion.h1>
      </div>
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.7 }}
        data-testid="hero-tagline"
        className="mx-auto mt-6 max-w-xl text-lg font-light text-white/75 md:text-xl"
      >
        I'm a Designer &amp; Animator based in {PROFILE.location}
      </motion.p>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="mt-10 flex items-center justify-center gap-4"
      >
        <a
          data-testid="hero-view-work-btn"
          href="#portfolio"
          onClick={(e) => {
            e.preventDefault();
            window.__lenis?.scrollTo("#portfolio", { duration: 1.4 });
          }}
          className="rounded-full bg-accent px-8 py-3 text-sm font-medium uppercase tracking-wider text-white transition-all duration-400 hover:-translate-y-0.5 hover:brightness-110"
        >
          View Portfolio
        </a>
        <a
          data-testid="hero-contact-btn"
          href="#contact"
          onClick={(e) => {
            e.preventDefault();
            window.__lenis?.scrollTo("#contact", { duration: 1.4 });
          }}
          className="rounded-full border border-white/40 px-8 py-3 text-sm font-medium uppercase tracking-wider text-white transition-all duration-400 hover:border-white hover:bg-white hover:text-[#212529]"
        >
          Get In Touch
        </a>
      </motion.div>
    </div>

    <motion.a
      data-testid="hero-scroll-indicator"
      href="#portfolio"
      onClick={(e) => {
        e.preventDefault();
        window.__lenis?.scrollTo("#portfolio", { duration: 1.4 });
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay: 1.4 }}
      className="absolute bottom-8 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center gap-2"
    >
      <span className="flex h-10 w-6 justify-center rounded-full border-2 border-white/60 pt-2">
        <span className="animate-scroll-dot h-1.5 w-1.5 rounded-full bg-white" />
      </span>
      <span className="text-[10px] uppercase tracking-[0.3em] text-white/60">Scroll</span>
    </motion.a>
  </section>
);
